import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectMilestoneApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-milestone'
    }

}